import {
  getScrollTop,
  getScrollEventTarget,
  scrollTo,
  scrollContainerMediaQuery,
} from '@theme/scroll-container';

class BackToTop extends HTMLElement {
  #scrollContainer = null;
  #scrollRafId = null;

  connectedCallback() {
    this.button = this.querySelector('.back_top_button');

    if (!this.button) return;

    this.handleScroll = this.handleScroll.bind(this);
    this.handleClick = this.handleClick.bind(this);
    this.handleBreakpointChange = this.handleBreakpointChange.bind(this);

    // Get Atelier's actual scroll container
    this.#scrollContainer = getScrollEventTarget();

    this.#scrollContainer.addEventListener('scroll', this.handleScroll);

    this.button.addEventListener('click', this.handleClick);

    // Rebind if Atelier switches scroll containers
    scrollContainerMediaQuery.addEventListener(
      'change',
      this.handleBreakpointChange
    );

    // Set initial state
    this.updateVisibility();
  }

  disconnectedCallback() {
    this.#scrollContainer?.removeEventListener('scroll', this.handleScroll);

    this.button?.removeEventListener('click', this.handleClick);

    scrollContainerMediaQuery.removeEventListener(
      'change',
      this.handleBreakpointChange
    );

    if (this.#scrollRafId !== null) {
      cancelAnimationFrame(this.#scrollRafId);
      this.#scrollRafId = null;
    }

    this.#scrollContainer = null;
  }

  handleScroll() {
    // Prevent running the update too many times during scrolling
    if (this.#scrollRafId !== null) return;

    this.#scrollRafId = requestAnimationFrame(() => {
      this.#scrollRafId = null;
      this.updateVisibility();
    });
  }

  updateVisibility() {
    const scrollTop = getScrollTop();

    const threshold = Number(this.dataset.scrollThreshold) || 300;

    if (scrollTop > threshold) {
      this.classList.add('is-visible');
    } else {
      this.classList.remove('is-visible');
    }
  }

  handleBreakpointChange() {
    if (!this.#scrollContainer) return;

    // Remove listener from old scroll container
    this.#scrollContainer.removeEventListener('scroll', this.handleScroll);

    // Get Atelier's new scroll container
    this.#scrollContainer = getScrollEventTarget();

    // Listen to the new scroll container
    this.#scrollContainer.addEventListener('scroll', this.handleScroll);

    this.updateVisibility();
  }

    handleClick() {
        scrollTo({
            top: 0,
            behavior: 'smooth',
        });
    }
}

if (!customElements.get('back-to-top')) {
  customElements.define('back-to-top', BackToTop);
}